import { useQuery } from "@tanstack/react-query";
import { useVault } from "./useVault";
import { useSession } from "../stores/session";

export function useDirListing(path: string) {
  const vault = useVault();
  const session = useSession((s) => s.session);
  return useQuery({
    enabled: !!session,
    queryKey: ["dir", session?.handle, path] as const,
    queryFn: async () => {
      if (!session) throw new Error("no session");
      return vault.listDir(session.handle, path);
    },
  });
}
